var _defs, _path, _path2, _path3, _path4, _rect, _g, _g2, _polygon, _polygon2, _rect2, _rect3, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBandNewsLogos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 111.82 105.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #2d2e71;\n      }\n\n      .cls-3 {\n        fill: #2b3176;\n      }\n\n      .cls-4 {\n        fill: none;\n        stroke: #c42329;\n        stroke-miterlimit: 10;\n        stroke-width: .65px;\n      }\n\n      .cls-5 {\n        fill: #c42329;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M4.39,71.66h-.15c-2.15,0-3.91,1.76-3.91,3.91v19.44c0,2.15,1.76,3.91,3.91,3.91h.15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M107.43,98.92h.15c2.15,0,3.91-1.76,3.91-3.91v-19.44c0-2.15-1.76-3.91-3.91-3.91h-.15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.43,79.96l-31.04-.21v6.82s-.54,5.1,4.77,3.09c4.8-1.81,22.82-8.25,26.27-9.49v-.21h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M107.4,65.1H4.25v11.16c0,2.15,1.76,3.91,3.91,3.91h99.23v-15.07h0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 4.29,
    y: 12.23,
    width: 103.15,
    height: 50.93
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.94,2.06h5.88c.8,0,1.29.07,1.67.26.52.27.96.93.96,1.71,0,.67-.27,1.38-1.09,1.61v.02c.43.12.75.47.8,1.09l.12,1.55c.03.32.16.6.35.83h-3.05c-.11-.21-.1-.52-.15-1.34-.03-.52-.21-.84-.72-.84h-1.98v2.18h-2.79V2.06h0ZM12.73,5.17h1.98c.55,0,.77-.22.77-.66,0-.54-.35-.66-.81-.66h-1.94v1.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.47,2.06h3.43l3.01,7.07h-2.97l-.3-.81h-2.91l-.3.81h-2.97l3.01-7.07h0ZM22.57,0h3l-1.52,1.43h-2.39l.9-1.43h0ZM23.19,4.2h-.02l-.83,2.4h1.68l-.83-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.26,2.06h5.44c2.4,0,3.67.93,3.67,3.54s-1.26,3.54-3.61,3.54h-5.5V2.06h0ZM31.06,7.35h1.6c1.28,0,1.79-.63,1.79-1.75s-.52-1.75-1.79-1.75h-1.6v3.51h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 38.38,
    y: 2.06,
    width: 2.79,
    height: 7.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.03,1.81c1.69,0,4.83.12,4.83,3.78s-3.14,3.78-4.83,3.78-4.83-.11-4.83-3.78,3.14-3.78,4.83-3.78M47.03,7.6c1.15,0,1.86-.57,1.86-2s-.71-2-1.86-2-1.86.57-1.86,2,.71,2,1.86,2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.97,17.01h8.98l7.89,19.9h-7.79l-.78-2.29h-7.63l-.78,2.29h-7.79l7.89-19.9h0ZM43.49,23.03h-.05l-2.18,6.75h4.41l-2.18-6.75h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.02,17.01h16.66c3.79,0,5.48,1.78,5.48,4.96,0,1.76-.8,3.29-2.21,3.88v.05c2.39.67,3.17,3.07,3.17,4.54,0,3.9-1.82,6.47-7.24,6.47h-15.86v-19.9h0ZM17.19,24.42h5.53c1.48,0,1.82-.53,1.82-1.31,0-.73-.34-1.25-1.82-1.25h-5.53v2.56h0ZM17.19,32.06h6.26c1.45,0,1.89-.67,1.89-1.56s-.44-1.56-1.89-1.56h-6.26v3.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "54.81 17.01 63.17 17.01 70.59 28.05 70.67 28.05 70.67 17.01 77.68 17.01 77.68 36.91 69.66 36.91 61.87 25.76 61.82 25.76 61.82 36.91 54.81 36.91 54.81 17.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.32,17.01h14.25c6.28,0,9.6,2.62,9.6,9.95s-3.3,9.95-9.45,9.95h-14.4v-19.9h0ZM86.64,31.89h4.2c3.35,0,4.7-1.78,4.7-4.93s-1.35-4.93-4.7-4.93h-4.2v9.87Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "9.97 39.12 18.1 39.12 25.32 49.85 25.39 49.85 25.39 39.12 32.21 39.12 32.21 58.47 24.41 58.47 16.84 47.63 16.79 47.63 16.79 58.47 9.97 58.47 9.97 39.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "33.87 39.12 53.02 39.12 53.02 43.83 40.98 43.83 40.98 46.44 52.16 46.44 52.16 51.15 40.98 51.15 40.98 53.76 53.02 53.76 53.02 58.47 33.87 58.47 33.87 39.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "51.76 39.12 58.65 39.12 60.97 50.94 61.02 50.94 63.67 39.12 69.35 39.12 71.98 50.94 72.03 50.94 74.35 39.12 81.24 39.12 75.96 58.47 68.97 58.47 66.53 47.74 66.48 47.74 64 58.47 57.01 58.47 51.76 39.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.64,50.26c-3.57-.58-5.05-2.81-5.05-5.59,0-5.15,4.69-6.54,10.7-6.54,8.24,0,11.63,2.31,11.89,6.51h-8.5c0-.81-.44-1.31-1.11-1.59-.65-.31-1.48-.42-2.28-.42-2.18,0-2.93.58-2.93,1.42,0,.56.23.92.96,1.03l8.73,1.39c3.68.58,5.96,2.42,5.96,5.79,0,4.84-3.68,7.12-11.89,7.12-5.62,0-11.76-.84-11.79-6.68h8.81c.03.67.26,1.11.78,1.42.54.28,1.35.42,2.49.42,2.28,0,2.9-.67,2.9-1.61,0-.58-.34-1.17-1.32-1.34l-8.34-1.34h0Z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "80.32 67.39 88.43 67.39 88.43 70.08 83.55 70.08 83.55 71.38 87.74 71.38 87.74 73.88 83.55 73.88 83.55 77.87 80.32 77.87 80.32 67.39"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "88.97 67.39 93.22 67.39 94.61 73.56 94.63 73.56 96.02 67.39 100.27 67.39 100.27 77.87 97.45 77.87 97.45 71.15 97.42 71.15 95.73 77.87 93.51 77.87 91.82 71.15 91.79 71.15 91.79 77.87 88.97 77.87 88.97 67.39"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4.29,
    y: 97.72,
    width: 2.04,
    height: 2.04
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 105.39,
    y: 97.72,
    width: 2.04,
    height: 2.04
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.26,105.03H7.04c.21-5.26,3.32-7.13,7.34-8.26l3.82-1.07c.91-.25,1.65-.82,1.65-1.6,0-1.01-.98-1.71-3.04-1.74-1.94,0-3.43.75-3.59,2.58h-5.63c.32-4.66,4.12-6.11,9.24-6.11s8.64,1.76,8.64,5.33c0,5.99-10.38,4.44-12.62,7.34h12.42v3.52h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.5,97.19c0,4.23-2.35,8.21-9.28,8.21s-9.28-3.98-9.28-8.21,2.31-8.35,9.28-8.35,9.28,4,9.28,8.35ZM32.19,97.19c0,3.77,2.22,4.69,4.02,4.69s4.02-.8,4.02-4.69-2.22-4.82-4.02-4.82-4.02.91-4.02,4.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M52.01,93.71h4.61l4.87,11.32h-4.04l-.68-1.84h-4.95l-.68,1.84h-4.04l4.92-11.32h0ZM54.31,96.57h-.03l-1.57,4.28h3.17l-1.57-4.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M61.8,93.71h4.35l5.25,7.09h.03v-7.09h3.65v11.32h-4.17l-5.42-7.15h-.03v7.15h-3.65v-11.32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83.75,93.36c4,0,7.37,1.32,7.37,6.01s-3.38,6.01-7.37,6.01-7.37-1.32-7.37-6.01,3.38-6.01,7.37-6.01ZM83.75,102.84c2.03,0,3.38-1.09,3.38-3.47s-1.35-3.47-3.38-3.47-3.38,1.11-3.38,3.47,1.36,3.47,3.38,3.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M100.26,97.02c-.11-.78-.73-1.32-2.46-1.32-1.27,0-1.97.36-1.97,1.11,0,.38.27.6.84.7.95.16,3.85.59,4.96.78,2.11.36,3.38,1.22,3.38,3.22,0,3.84-4.98,3.87-6.53,3.87-3.84,0-6.61-.68-6.83-3.84h4.47c.1.86.57,1.39,2.54,1.39.95,0,1.98-.22,1.98-1.19,0-.6-.48-.81-1.79-1.01l-3.77-.57c-2.33-.35-3.23-1.52-3.23-3.2,0-1.49.92-3.6,5.88-3.6,4.11,0,6.58.98,6.82,3.66h-4.28Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBandNewsLogos);
export default __webpack_public_path__ + "static/media/Band_news_logos.4b3c72c972aef3f81ca9a85d7f0fb845.svg";
export { ForwardRef as ReactComponent };